<template>
  <div class="">
    <div class="page-title">
      <div class="title_left">
        <h3>{{ pageTitle || $router.currentRoute.name }}</h3>
      </div>

      <div class="title_right">
        <!--        <div class="col-md-5 col-sm-5   form-group pull-right top_search">-->
        <!--          <div class="input-group">-->
        <!--            <input class="form-control" placeholder="Search for..." type="text">-->
        <!--            <span class="input-group-btn">-->
        <!--                      <button class="btn btn-default" type="button">Go!</button>-->
        <!--                    </span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="clearfix"></div>

    <div class="row">
      <div class="col-md-12 col-sm-12">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageContent",
  props: {
    pageTitle: String
  }
}
</script>

<style scoped>

</style>